/**
 * @Author: Zewei
 * @Date:   2018-01-19T10:31:12+08:00
 * @Last modified by:
 * @Last modified time: 2018-01-29T17:08:46+08:00
 */

import React, { Component } from 'react';
// import logo from './logo.svg';
import { Provider } from 'react-redux';
import AppRouter from './router';
import { store } from "./store/store";
// import createHistory from 'history/createBrowserHistory';
// import { ConnectedRouter } from 'react-router-redux';

import './App.css';
const websiteConfig = require("./config.json");

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
    // console.log(error)
    if (websiteConfig.prod) {
      window.location.href = "/404";
    }
  }

  render() {
    if (!this.state.hasError || !websiteConfig.prod) {
			return this.props.children;
    }
  }
}

class App extends Component {
	render() {
			return <Provider store={store}>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </Provider>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js